import styled from 'styled-components'
import { omniaTheme } from '../../theme/omniaTheme'

// ============================================================
// Page-level wrapper
// ============================================================

export const MarketContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10mm 10mm 10mm 10mm;
  box-sizing: border-box;

  @media print {
    width: 100% !important;
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 10mm 10mm 10mm 10mm !important;
  }
`

// ============================================================
// Section spacing helpers
// ============================================================

export const GapXLarge = styled.div`
  height: 24px;

  @media print {
    height: 24px !important;
  }
`

export const GapMedium = styled.div`
  height: 16px;

  @media print {
    height: 16px !important;
  }
`

// ============================================================
// Aperçu du marché card
// ============================================================

export const SummaryCard = styled.div`
  background: ${omniaTheme.colors.cardBg};
  width: 100%;
  min-height: 104px;
  padding: 24px;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media print {
    background: ${omniaTheme.colors.cardBg} !important;
    width: 100% !important;
    min-height: 104px !important;
    padding: 24px !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 12px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SummaryTitle = styled.h3`
  font-family: ${omniaTheme.fonts.heading};
  font-size: 14px;
  font-weight: ${omniaTheme.fontWeights.medium};
  color: ${omniaTheme.colors.black};
  letter-spacing: ${omniaTheme.letterSpacing.tight};
  margin: 0;

  @media print {
    font-family: ${omniaTheme.fonts.heading} !important;
    font-size: 14px !important;
    font-weight: ${omniaTheme.fontWeights.medium} !important;
    color: ${omniaTheme.colors.black} !important;
    letter-spacing: ${omniaTheme.letterSpacing.tight} !important;
    margin: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SummaryBody = styled.p`
  font-family: ${omniaTheme.fonts.body};
  font-size: 11px;
  font-weight: ${omniaTheme.fontWeights.light};
  color: ${omniaTheme.colors.text};
  line-height: 1.5;
  margin: 0;
  white-space: pre-wrap;

  @media print {
    font-family: ${omniaTheme.fonts.body} !important;
    font-size: 11px !important;
    font-weight: ${omniaTheme.fontWeights.light} !important;
    color: ${omniaTheme.colors.text} !important;
    line-height: 1.5 !important;
    margin: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

// ============================================================
// 4 stat cards row
// ============================================================

export const StatRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 12px;

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr 1fr !important;
    gap: 12px !important;
  }
`

export const StatCard = styled.div`
  background: ${omniaTheme.colors.cardBg};
  height: 104px;
  padding: 16px;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-sizing: border-box;

  @media print {
    background: ${omniaTheme.colors.cardBg} !important;
    height: 104px !important;
    padding: 16px !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 12px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatValue = styled.div`
  font-family: ${omniaTheme.fonts.heading};
  font-size: 16px;
  font-weight: ${omniaTheme.fontWeights.light};
  color: ${omniaTheme.colors.black};
  letter-spacing: ${omniaTheme.letterSpacing.tight};
  line-height: 1.15;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;

  @media print {
    font-family: ${omniaTheme.fonts.heading} !important;
    font-size: 16px !important;
    font-weight: ${omniaTheme.fontWeights.light} !important;
    color: ${omniaTheme.colors.black} !important;
    letter-spacing: ${omniaTheme.letterSpacing.tight} !important;
    line-height: 1.15 !important;
    text-align: center !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatValueLarge = styled.div`
  font-family: ${omniaTheme.fonts.heading};
  font-size: 22px;
  font-weight: ${omniaTheme.fontWeights.light};
  color: ${omniaTheme.colors.black};
  letter-spacing: ${omniaTheme.letterSpacing.tight};
  line-height: 1;
  text-align: center;

  @media print {
    font-family: ${omniaTheme.fonts.heading} !important;
    font-size: 22px !important;
    font-weight: ${omniaTheme.fontWeights.light} !important;
    color: ${omniaTheme.colors.black} !important;
    letter-spacing: ${omniaTheme.letterSpacing.tight} !important;
    line-height: 1 !important;
    text-align: center !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatLabel = styled.div`
  font-family: ${omniaTheme.fonts.label};
  font-size: 9px;
  font-weight: ${omniaTheme.fontWeights.light};
  letter-spacing: ${omniaTheme.letterSpacing.wide};
  color: ${omniaTheme.colors.textLabel};
  text-transform: uppercase;
  text-align: center;
  line-height: 1.3;

  @media print {
    font-family: ${omniaTheme.fonts.label} !important;
    font-size: 9px !important;
    font-weight: ${omniaTheme.fontWeights.light} !important;
    letter-spacing: ${omniaTheme.letterSpacing.wide} !important;
    color: ${omniaTheme.colors.textLabel} !important;
    text-transform: uppercase !important;
    text-align: center !important;
    line-height: 1.3 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

// ============================================================
// Comparables — subhead + grid + cards
// ============================================================

export const ComparablesSubhead = styled.h3`
  font-family: ${omniaTheme.fonts.heading};
  font-size: 14px;
  font-weight: ${omniaTheme.fontWeights.medium};
  color: ${omniaTheme.colors.black};
  letter-spacing: ${omniaTheme.letterSpacing.tight};
  margin: 0;

  @media print {
    font-family: ${omniaTheme.fonts.heading} !important;
    font-size: 14px !important;
    font-weight: ${omniaTheme.fontWeights.medium} !important;
    color: ${omniaTheme.colors.black} !important;
    letter-spacing: ${omniaTheme.letterSpacing.tight} !important;
    margin: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ComparablesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  width: 100%;
  gap: 16px;
  row-gap: 24px;

  @media print {
    display: grid !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    width: 100% !important;
    gap: 16px !important;
    row-gap: 24px !important;
  }
`

export const ComparableCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;

  @media print {
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    background: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
`

export const ComparablePhoto = styled.div<{ $imageUrl?: string }>`
  width: 100%;
  /* 16:9 aspect — matches Property Showcase comparable hero proportions
     (wider, slightly shorter than 5:3 so the photo reads as the card hero). */
  aspect-ratio: 16 / 9;
  background: ${({ $imageUrl }) =>
    $imageUrl ? `url('${$imageUrl}') center/cover no-repeat` : '#C9D6DE'};
  display: flex;
  align-items: center;
  justify-content: center;

  @media print {
    width: 100% !important;
    aspect-ratio: 16 / 9 !important;
    background: ${({ $imageUrl }) =>
      $imageUrl
        ? `url('${$imageUrl}') center/cover no-repeat !important`
        : 'transparent !important'};
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ComparableContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 12px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: 2px !important;
    padding-top: 12px !important;
  }
`

export const ComparablePrice = styled.div`
  font-family: ${omniaTheme.fonts.heading};
  font-size: 14px;
  font-weight: ${omniaTheme.fontWeights.light};
  color: ${omniaTheme.colors.black};
  letter-spacing: ${omniaTheme.letterSpacing.tight};
  line-height: 1.2;
  margin-bottom: 4px;

  @media print {
    font-family: ${omniaTheme.fonts.heading} !important;
    font-size: 14px !important;
    font-weight: ${omniaTheme.fontWeights.light} !important;
    color: ${omniaTheme.colors.black} !important;
    letter-spacing: ${omniaTheme.letterSpacing.tight} !important;
    line-height: 1.2 !important;
    margin-bottom: 4px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ComparableMeta = styled.div`
  font-family: ${omniaTheme.fonts.body};
  font-size: 9.5px;
  font-weight: ${omniaTheme.fontWeights.normal};
  color: ${omniaTheme.colors.textMuted};
  line-height: 1.4;

  @media print {
    font-family: ${omniaTheme.fonts.body} !important;
    font-size: 9.5px !important;
    font-weight: ${omniaTheme.fontWeights.normal} !important;
    color: ${omniaTheme.colors.textMuted} !important;
    line-height: 1.4 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ComparablePricePerSqm = styled.div`
  font-family: ${omniaTheme.fonts.body};
  font-size: 9.5px;
  font-weight: ${omniaTheme.fontWeights.normal};
  color: ${omniaTheme.colors.text};
  line-height: 1.4;
  margin-top: 4px;

  @media print {
    font-family: ${omniaTheme.fonts.body} !important;
    font-size: 9.5px !important;
    font-weight: ${omniaTheme.fontWeights.normal} !important;
    color: ${omniaTheme.colors.text} !important;
    line-height: 1.4 !important;
    margin-top: 4px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ComparablePhotoPlaceholder = styled.span`
  font-family: ${omniaTheme.fonts.body};
  font-size: 9px;
  font-weight: ${omniaTheme.fontWeights.light};
  color: #5f6e55;

  /* Hidden in the PDF — empty comparable photos stay blank, no label. */
  @media print {
    display: none !important;
  }
`
